import { useQuery, UseQueryResult } from '@taxdown/zeno-sama-query';
import RecordsService from 'Services/records';
import { useGetQuery } from 'Hooks/useGetQuery';
import { CustomerType, QueryKeys, ResponseType, ResultType } from 'Types/common';

export const resultSelector = (response: ResponseType<ResultType>): ResultType => {
  const { data } = response;
  const dataFiltered = {
    mandatory: data.item.mandatory,
    taxReturnResult: data.item.taxReturnResult,
    taxReturnSubType: data.item.taxReturnSubType,
    taxReturnType: data.item.taxReturnType,
    warnings: data.item.warnings,
  } as ResultType;

  return dataFiltered;
};
export const useFetchAmountResult = (haveRecordId: boolean): UseQueryResult<ResultType> =>
  useQuery([QueryKeys.FETCH_GET_RESULT], RecordsService.getResultData, {
    select: data => resultSelector(data),
    refetchOnWindowFocus: false,
    enabled: haveRecordId,
    retry: 0,
    cacheTime: 0,
  });

export const useGetCustomerInfo = (): CustomerType | undefined => {
  const data = useGetQuery<ResponseType<CustomerType>>([QueryKeys.FETCH_GET_CUSTOMER]);
  const response = data?.data;
  const info = response?.item;
  return info;
};
